// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__24ERy","spin":"Spinner_spin__2cA5G"};